import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { navigationService } from '../../services/navigation.service';
import { NavItem } from '../../models/navItem';

const NavFooter: React.FC = () => {
  const [menuItems, setMenuItems] = useState<NavItem[]>([]);

  const location = "footer";

  const fetchMenuItems = async () => {
    const items = await navigationService.getNavigationItems(location);
    setMenuItems(items);
  };

  useEffect(() => {
    fetchMenuItems();
  }, [location]);

  return (
    <nav className="navigation nav-footer">
      <div className="container">
        <div className="row">
          <div className="col-md-12 col-lg-12">
            <ul>
              {menuItems.map(({ path, name }) => (
                <li key={path}>
                  {path.startsWith('http') ? (
                    <a href={path} target="_blank" rel="noopener noreferrer">{name}</a>
                  ) : (
                    <Link to={path}>{name}</Link>
                  )}
                </li>
              ))}
              <li className="copyright"><a href="https://stichting.mijnaansluiting.nl/" target="_blank">© Stichting Mijn Aansluiting | 2025</a></li>
            </ul>
          </div>
        </div>
      </div>
    </nav>
  );
}

export default NavFooter;
